
































import { vxm } from '@/store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';

declare var window: any;
@Component({
  name: 'ErrorMessage',
  components: {},
})
export default class ErrorMessage extends Vue {
  $wlToastr: any;
  get SpinnerLogo(): string {
    return vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_LOGO_SPINER_URL');
  }

  get isHTMLMessage() {
    return /\s*</.test(this.errorMessage);
  }
  get errorMessage() {
    // return window.WorkLLama.errorMessage;
    return window.WorkLLama.errorMessage.replace(/<\/?[^>]+(>|$)/g, ' ');
  }
  get historyLength() {
    return history.length;
  }
  get getLink() {
    if (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_BEFORE_SIGN_IN') ===
        'COMPANY_PROFILE' &&
      !vxm.users.isLoggedIn
    ) {
      return `/companyprofile/${vxm.jobs.BrandingInfo.companycode}`;
    } else {
      return '/';
    }
  }
  mounted() {
    vxm.utility.setAppWebView(true);
    this.setbcakButtonTimer();
    this.$wlToastr('error', this.$t(this.errorMessage), '');
  }
  setbcakButtonTimer() {
    var noCounter = document.querySelector('.no-back-counter'),
      counterInit: any = document.querySelector('.back-counter-init'),
      counter: any = document.querySelector('span.back.counter'),
      countEl: any = document.querySelector('span.back.count'),
      count: any =
        (counterInit && parseInt(counterInit.getAttribute('data-count'))) || 5;

    if (noCounter || !counter) return;

    counter.style.display = 'inline';
    countEl.innerText = count.toString();
    setInterval(function () {
      count--;
      if (count < 0) {
        counter.style.display = 'none';
        history.go(-2);
      } else if (history.length > 1) {
        countEl.innerText = count;
      } else {
        counter.style.display = 'none';
      }
    }, 1000);
  }
}
